// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2EqxH","search":"Settings_search__2cSo9","filter":"Settings_filter__2xlu3"};